import { render, staticRenderFns } from "./BaseFilterSelect.vue?vue&type=template&id=edd86456&scoped=true&"
import script from "./BaseFilterSelect.vue?vue&type=script&lang=js&"
export * from "./BaseFilterSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseFilterSelect.vue?vue&type=style&index=0&id=edd86456&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd86456",
  null
  
)

export default component.exports